import type { Staff } from './types';
import { isoOfBoardDate } from './logic';

// Lọc / sắp xếp danh sách nhân sự (script board Mint-HR, khối `STAFF2`). Không lương, không CCCD.

export const STAFF_DEPT_FILTERS = ['Tất cả', 'Kinh doanh', 'Dịch vụ KH', 'Vận tải', 'Kế toán', 'Ban giám đốc'] as const;

/** Loại hợp đồng hiện theo hồ sơ (board `CT`); nguồn thật là hợp đồng đã ký (J-04). */
export const STAFF_CONTRACT: Readonly<Record<string, string>> = {
  DAVID: 'HĐ không thời hạn', PHILIP: 'HĐ không thời hạn', HANHLTM: 'HĐ không thời hạn', PHONGNT: 'HĐ không thời hạn', NhungTT: 'HĐ 36 tháng',
  MAITTN: 'HĐ 12 tháng', TUANNT: 'HĐ 12 tháng', PhuongHT: 'HĐ 36 tháng', NhiTHT: 'HĐ 12 tháng', THANHTTK: 'HĐ 12 tháng', LAN: 'Thử việc', 'BẢO': 'Thử việc',
};

export interface StaffFilter {
  st?: string;
  seat?: string;
  ct?: string;
  sort?: string;
}

/** Bỏ dấu + hạ chữ để tìm không phân biệt dấu. */
export const norm = (x: string): string =>
  x.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();

export function filterStaff(all: readonly Staff[], o: StaffFilter & { q: string; dept: string }): Staff[] {
  let r = all.filter((x) => (o.dept === 'Tất cả' || x.dept.includes(o.dept))
    && (!o.q || norm([x.id, x.name, x.dept, ...x.seats.map((h) => h.code)].join(' ')).includes(norm(o.q))));
  if (o.st) r = r.filter((x) => x.status === o.st);
  if (o.seat) r = r.filter((x) => x.seats.some((h) => h.code === o.seat));
  if (o.ct) r = r.filter((x) => STAFF_CONTRACT[x.id] === o.ct);
  if (o.sort === 'name') r = [...r].sort((a, b) => a.name.localeCompare(b.name, 'vi'));
  if (o.sort === 'join') r = [...r].sort((a, b) => (isoOfBoardDate(b.joined) ?? '').localeCompare(isoOfBoardDate(a.joined) ?? ''));
  if (o.sort === 'leave') r = [...r].sort((a, b) => a.leaveLeft - b.leaveLeft);
  return r;
}
